var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Data Vis/Indicator/Point") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Data-Vis/Indicator/Point",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,0 C10.0898509,0 13,2.91014913 13,6.5 C13,10.0898509 10.0898509,13 6.5,13 C2.91014913,13 0,10.0898509 0,6.5 C0,2.91014913 2.91014913,0 6.5,0 Z M6.5,1 C3.46243388,1 1,3.46243388 1,6.5 C1,9.46347915 3.34378001,11.8795391 6.27879286,11.9956328 L6.5,12 L6.72120714,11.9956328 C9.65621999,11.8795391 12,9.46347915 12,6.5 C12,3.46243388 9.53756612,1 6.5,1 Z",
    id: "Oval",
    fillOpacity: 0.15,
    fill: "#161617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,1 C3.46243388,1 1,3.46243388 1,6.5 C1,9.53756612 3.46243388,12 6.5,12 C9.53756612,12 12,9.53756612 12,6.5 C12,3.46243388 9.53756612,1 6.5,1 Z M6.5,3 C8.43299662,3 10,4.56700338 10,6.5 C10,8.43299662 8.43299662,10 6.5,10 C4.56700338,10 3,8.43299662 3,6.5 C3,4.56700338 4.56700338,3 6.5,3 Z",
    id: "Oval",
    fill: "#47ADC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,3 C8.43299662,3 10,4.56700338 10,6.5 C10,8.43299662 8.43299662,10 6.5,10 C4.56700338,10 3,8.43299662 3,6.5 C3,4.56700338 4.56700338,3 6.5,3 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/Point.c133ddb62e4caeab87909a048186f9fa.svg";
export { ForwardRef as ReactComponent };